<template>
  <main class="main page-inside text-page contact-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title">
            Feel free to reach out to us by any of the following means of
            communication: <br /><br />
            E-mail:
            <a v-if="supportEmail" :href="'mailto:' + supportEmail">{{
              supportEmail
            }}</a>
            <br /><br />
            Phone:
            <a
              v-if="supportPhone"
              :href="'tel:' + (supportPhone.replace(/[\s()-]/g, '') || '')"
              >{{ supportPhone }}</a
            >
            <br /><br />
            Or use the form below instead!
          </div>
          <div class="form-fields-wrapper">
            <label>
              <input type="text" :placeholder="'Name'" v-model="name" />
            </label>
            <label>
              <input type="text" :placeholder="'Surname'" v-model="surname" />
            </label>
            <label>
              <input
                type="email"
                :placeholder="'E-mail address'"
                v-model="email"
              />
            </label>

            <label>
              <input
                type="number"
                @input="allowOnlyNumbers"
                placeholder="Phone"
                v-model="phone"
              />
            </label>
            <label class="full">
              <input type="text" :placeholder="'Topic'" v-model="topic" />
            </label>
            <label class="full">
              <textarea :placeholder="'Message'" v-model="message"></textarea>
            </label>
            <button @click="contactSubmit" class="button">Send</button>
            <transition name="fade">
              <div v-if="error" class="error-desc desc red">{{ error }}</div>
            </transition>
            <transition name="fade">
              <div v-if="successMessage" class="error-desc desc green">
                {{ successMessage }}
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "Contact",
  props: ["supportPhone", "supportEmail"],
  data: function () {
    return {
      successMessage: "",
      error: "",
      name: "",
      surname: "",
      email: "",
      message: "",
      topic: "",
      phone: "",
    };
  },
  mounted() {
    this.getCountries();
  },
  methods: {
    allowOnlyNumbers(e) {
      var regex = RegExp(/[0-9]+/g);
      const test_result = regex.test(e.target.value);

      if (test_result) {
        e.target.defaultValue = e.target.value;
      } else {
        e.target.value = e.target.defaultValue;
      }
    },
    contactSubmit() {
      let data = {
        name: this.name,
        surname: this.surname,
        email: this.email,
        topic: this.topic,
        message: this.message,
        phone: this.phone,
      };
      let self = this;
      this.$http
        .post(process.env.VUE_APP_API + "contact-us", data)
        .then((res) => {
          if (res.data.status == "OK") {
            self.error = "";
            self.successMessage = "Thank you!";
            setTimeout(function () {
              self.successMessage = "";
            }, 2000);
          } else {
            this.error = res.data.message;
          }
        })
        .catch((res) => {
          this.error = res.response.data.message;
        });
    },
  },
};
</script>
